import { getCookie } from 'cookies-next'

// Snapchat Click ID (sccid) - used for attribution tracking
export function getSccid() {
  return (
    (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('sccid')) ||
    getCookie('sccid') ||
    null
  )
}

// Snapchat First-Party Cookie (_scid) - used for CAPI (Conversion API) matching
// Also known as sc_cookie1 or uuid_c1 in Snapchat's API
export function getScCookie1() {
  return getCookie('_scid') || null
}
